import { IBlocktimeReportTotalValueViewModel } from './block-time-report.model';

export const totalOfBlockTimeReportValues: IBlocktimeReportTotalValueViewModel[] = [
  {
    prop: 'count',
    title: 'Flight Count',
    sum: 0,
    subTotal: 0,
  },
  {
    prop: 'sumOBRepoHours',
    title: 'OB Repo Hours',
    sum: 0,
    subTotal: 0,
  },
  {
    prop: 'sumLiveFlightHours',
    title: 'Live Flight Hours',
    sum: 0,
    subTotal: 0,
  },
  {
    prop: 'sumIBRepoHours',
    title: 'IB Repo Hours',
    sum: 0,
    subTotal: 0,
  },
  {
    prop: 'sumActualBlockTime',
    title: 'Actual Flight Hours',
    sum: 0,
    subTotal: 0,
  },
  {
    prop: 'sumCancellationHours',
    title: 'Cancellation Hours',
    sum: 0,
    subTotal: 0,
  },
  {
    prop: 'sumBilledHours',
    title: 'Billed Hours',
    sum: 0,
    subTotal: 0
  },
  {
    prop: 'sumEstimatedBlockHours',
    title: 'Estimated Hours',
    sum: 0,
    subTotal: 0
  },
  {
    prop: 'sumCost',
    title: 'Total Cost',
    sum: 0,
    subTotal: 0
  },
  {
    prop: 'sumProfit',
    title: 'Total Profit',
    sum: 0,
    subTotal: 0
  },
  {
    prop: 'sumRate',
    title: 'Total Rate',
    sum: 0,
    subTotal: 0
  },
  {
    prop: 'sumFlightMargin',
    title: 'Total Flight Margin',
    sum: 0,
    subTotal: 0
  },
];

export const subTotalReportSum: Record<string, string> = {
  sumOBRepoHours: 'obEstimatedBlockHours',
  sumLiveFlightHours: 'liveFlightHours',
  sumIBRepoHours: 'ibEstimatedBlockHours',
  sumActualBlockTime: 'actualBlockTime',
  sumCancellationHours: 'cancellationHours',
  sumBilledHours: 'totalBilledHours',
  sumEstimatedBlockHours: 'estimatedBlockHours',
  sumCost: 'cost',
  sumProfit: 'profit',
  sumRate: 'rate',
  sumFlightMargin: 'flightMargin',
};
